import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"app":""}},[_c('footer',{staticClass:"footer text-center"},[_vm._v("\n    All Rights Reserved by Xtreme Admin. Designed and Developed by\n    "),_c('a',{attrs:{"href":"https://wrappixel.com"}},[_vm._v("WrapPixel")]),_vm._v(".\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }